import { render, staticRenderFns } from "./Berlinale2025.vue?vue&type=template&id=3a3e420a&scoped=true"
import script from "./Berlinale2025.vue?vue&type=script&lang=js"
export * from "./Berlinale2025.vue?vue&type=script&lang=js"
import style0 from "./Berlinale2025.vue?vue&type=style&index=0&id=3a3e420a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3e420a",
  null
  
)

export default component.exports